import React from 'react';
import ArrowIcon from '../icons/ArrowIcon';

const AccordionTitle = ({ onClick, children }) => (

  <div className="accordion-title" onClick={onClick}>
    {children}
    <ArrowIcon />
  </div>
);

export default AccordionTitle;
